var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.055,
    height: 46.898,
    viewBox: "0 0 40.055 46.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(-37.355 -0.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55637",
    "data-name": "Path 55637",
    d: "M57.442,3.608c5.377,1.781,10.9,3.877,15.615,5.708A79.693,79.693,0,0,1,73.92,19.6a45.687,45.687,0,0,1-.529,8.847,13.041,13.041,0,0,1-2.428,4.339A35.316,35.316,0,0,1,65.1,38.408l0,0A52.376,52.376,0,0,1,57.442,43.4a52.167,52.167,0,0,1-7.647-4.979l0,0a35.192,35.192,0,0,1-5.86-5.618,13.405,13.405,0,0,1-2.366-4.138c-.011-.043-.023-.086-.037-.13-.183-.62-.772-3.118-.683-9.266a55.429,55.429,0,0,1,1.017-9.97c4.7-1.822,10.207-3.909,15.58-5.685m0-3.527a2.609,2.609,0,0,0-.821.133C51.353,1.944,45.949,3.975,40.454,6.1a3.656,3.656,0,0,0-1.762,1.462,49.869,49.869,0,0,0-1.327,11.628c-.117,8,.879,10.4.846,10.4a16.6,16.6,0,0,0,3,5.367,38.758,38.758,0,0,0,6.44,6.193,53.988,53.988,0,0,0,8.628,5.55,2.633,2.633,0,0,0,1.168.273h0a2.623,2.623,0,0,0,1.169-.275,54.136,54.136,0,0,0,8.631-5.555,38.888,38.888,0,0,0,6.442-6.194,16.148,16.148,0,0,0,3.1-5.738,45.415,45.415,0,0,0,.611-9.675,81.4,81.4,0,0,0-1.054-11.7,3.659,3.659,0,0,0-1.912-1.723c-5.5-2.13-10.9-4.164-16.169-5.9a2.631,2.631,0,0,0-.823-.134Z",
    transform: "translate(0 0)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55638",
    "data-name": "Path 55638",
    d: "M195.011,176.886a3.758,3.758,0,0,1-3.757-3.756V170.2a6.156,6.156,0,1,1,7.514-.086v3.02a3.758,3.758,0,0,1-3.756,3.757Zm-.056-14.286a2.675,2.675,0,0,0-1.187,5.072,1.74,1.74,0,0,1,.965,1.558v3.9a.278.278,0,0,0,.277.277.275.275,0,0,0,.276-.276v-3.954a1.74,1.74,0,0,1,.922-1.536,2.675,2.675,0,0,0-1.254-5.038Z",
    transform: "translate(-137.573 -144.472)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPrivacyPolicy);
export default __webpack_public_path__ + "static/media/settings-privacy-policy.dcf8174c3e9d5dd85b020d4f5b55601f.svg";
export { ForwardRef as ReactComponent };